import { render, staticRenderFns } from "./mcp.vue?vue&type=template&id=1378a0c8&scoped=true&"
import script from "./mcp.vue?vue&type=script&lang=js&"
export * from "./mcp.vue?vue&type=script&lang=js&"
import style0 from "./mcp.vue?vue&type=style&index=0&id=1378a0c8&scoped=true&lang=scss&"
import style1 from "./mcp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378a0c8",
  null
  
)

export default component.exports